export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/3a52d8110bcddfbbaf3a4b49a8936d4a.jpeg"
          alt="BR CLEAN AUTO Service"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Service de Nettoyage Auto<br />à Domicile
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto">
          Nous nous déplaçons directement chez vous avec un véhicule entièrement équipé pour répondre à tous vos besoins de nettoyage automobile, rénovation de phares, polissage, mise en valeur avant vente et finitions haut de gamme. Notre objectif est simple : redonner à votre véhicule un aspect impeccable, avec un service professionnel, flexible et efficace.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-[#0EA5E9] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#0284C7] transition-all hover:scale-105 whitespace-nowrap"
          >
            Réserver Maintenant
          </button>
          <button
            onClick={() => scrollToSection('prestations')}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap"
          >
            Nos Prestations
          </button>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-[#0EA5E9] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Service Mobile</h3>
            <p className="text-white/90 text-sm">Nous venons à vous partout à Clermont-Ferrand et alentours</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-[#0EA5E9] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Qualité Pro</h3>
            <p className="text-white/90 text-sm">Produits professionnels et équipement de pointe</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-[#0EA5E9] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Rapide</h3>
            <p className="text-white/90 text-sm">Service efficace sans compromis sur la qualité</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('prestations')}
          className="text-white hover:text-[#0EA5E9] transition-colors"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}